import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {OcorrenciasService} from '@core/services/ocorrencias.service';
import {catchError, map, of} from 'rxjs';
import {Ocorrencia} from '@core/models/ocorrencias';
import {MessageService} from 'primeng/api';
import {HttpErrorResponse} from '@angular/common/http';
import {SituacaoOcorrencia} from '@core/models/situacao-ocorrencia';

export const readonlyOcorrenciaGuard: CanActivateFn = (route, state) => {

  const router = inject(Router);
  const ocorrenciaService = inject(OcorrenciasService);
  const messageService = inject(MessageService);

  const id = route.paramMap.get('id');

  if (!id) {
    router.navigate(['/ocorrencias']).then(() => {
    });
    return false;
  }

  return ocorrenciaService.getById(Number(id)).pipe(
    map((ocorrencia: Ocorrencia) => {
      if (ocorrencia.readOnly) {
        messageService.add({
          severity: 'warn',
          summary: 'Atenção!',
          detail: `Usuário sem permissão para editar a Ocorrência ${ocorrencia.numeroOcorrencia}. Entre em contato com seu administrador.`,
          life: 6000
        })
        router.navigate(['/auth/no-permission']).then(() => {
        });
        return false;
      }
      if (ocorrencia.situacao === SituacaoOcorrencia.CANCELADA) {
        messageService.add({
          severity: 'warn',
          summary: 'Atenção!',
          detail: `Não é possível editar uma ocorrência cancelada.`,
          life: 5000
        });
        router.navigate(['/ocorrencias']).then();
        return false;
      }
      if (ocorrencia.bloqueado) {
        messageService.add({
          severity: 'warn',
          summary: 'Atenção!',
          detail: 'Não é possível editar uma ocorrência bloqueada.',
          life: 5000
        });
        router.navigate(['/ocorrencias']).then();
        return false;
      }
      return true;
    }),
    catchError((error: HttpErrorResponse) => {
      messageService.add({
        severity: 'error',
        summary: 'Erro!',
        detail: 'Erro ao carregar os dados da ocorrência.',
      })
      router.navigate(['/ocorrencias']).then();
      return of(false);
    })
  );
};
